'use client';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html>
      <body>
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'system-ui' }}>
          <div style={{ textAlign: 'center', maxWidth: '400px', padding: '32px' }}>
            <div style={{ fontSize: '64px', marginBottom: '16px' }}>💥</div>
            <h2 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '8px' }}>Critical Error</h2>
            <p style={{ color: '#666', marginBottom: '24px' }}>{error.message || 'A critical error occurred.'}</p>
            <button onClick={reset} style={{ padding: '12px 24px', background: '#7c3aed', color: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer', fontSize: '16px' }}>
              Reload
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
